import { MovementArticle } from "types";

type ObservationPreviewSummarySource = {
  observation?: string | null;
};

export const buildObservationPreviewSummary = (
  previewUnits: ObservationPreviewSummarySource[] = [],
) => {
  if (previewUnits.length === 0) {
    return null;
  }

  const uniqueObservations = Array.from(
    new Set(
      previewUnits
        .map((previewUnit) => previewUnit.observation?.trim() ?? "")
        .filter(Boolean),
    ),
  );

  if (uniqueObservations.length === 0) {
    return null;
  }

  return uniqueObservations.join(" - ");
};

export const buildMovementArticleObservationSummary = (
  movementArticle: MovementArticle,
) => {
  const previewSummary = buildObservationPreviewSummary(
    movementArticle.observation_preview_units ?? [],
  );

  if (previewSummary) {
    return previewSummary;
  }

  return (
    movementArticle.article_locations?.observation_available ??
    movementArticle.article_locations?.observation_not_available ??
    "-"
  );
};
